import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="role-selection"
export default class extends Controller {
  static targets = ["option", "checkIcon", "focusRing", "submitButton", "errorMessage"];

  connect() {
    // Initialize the form state
    this.updateSubmitButton();
  }

  handleRoleChange(event) {
    const selectedRadio = event.target;
    this.updateRoleSelection(selectedRadio);
    this.updateSubmitButton();
    this.hideErrorMessage();
  }

  updateRoleSelection(selectedRadio) {
    // Update all role option cards
    this.optionTargets.forEach((option, index) => {
      const radio = option.querySelector('input[type="radio"]');
      const checkIcon = this.checkIconTargets[index];
      const focusRing = this.focusRingTargets[index];

      if (radio === selectedRadio) {
        // Selected state
        option.classList.remove("border-stone-300");
        option.classList.add("border-[#6100FF]", "ring-2", "ring-[#6100FF]");
        checkIcon.classList.remove("opacity-0");
        checkIcon.classList.add("opacity-100");
        if (focusRing) {
          focusRing.classList.remove("border-transparent");
          focusRing.classList.add("border-[#6100FF]");
        }
      } else {
        // Unselected state
        option.classList.remove("border-[#6100FF]", "ring-2", "ring-[#6100FF]");
        option.classList.add("border-stone-300");
        checkIcon.classList.remove("opacity-100");
        checkIcon.classList.add("opacity-0");
        if (focusRing) {
          focusRing.classList.remove("border-[#6100FF]");
          focusRing.classList.add("border-transparent");
        }
      }
    });
  }

  updateSubmitButton() {
    const selectedRadio = this.element.querySelector('input[type="radio"]:checked');
    const submitButton = this.submitButtonTarget;

    if (selectedRadio) {
      submitButton.disabled = false;
      submitButton.classList.remove("opacity-50", "cursor-not-allowed");
    } else {
      submitButton.disabled = true;
      submitButton.classList.add("opacity-50", "cursor-not-allowed");
    }
  }

  hideErrorMessage() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.classList.add("hidden");
    }
  }

  showErrorMessage() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.classList.remove("hidden");
    }
  }
}
